import { motion } from "framer-motion";

const LogoMark = () => (
  <div className="w-8 h-8 rounded-lg bg-[#ff007f] flex items-center justify-center shadow-[0_0_14px_rgba(255,0,127,0.6)]">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M5 12.5 10 17.5 19 7" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
);

export default function Header() {
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-[580px] bg-[#0c0c10]/80 backdrop-blur-xl border border-[#ff007f]/30 rounded-full px-5 py-3 flex items-center justify-between shadow-[0_0_25px_rgba(0,0,0,0.8)]"
      data-testid="header-bar"
    >
      <a href="/" data-testid="header-home-link" className="flex items-center gap-2.5 no-underline">
        <LogoMark />
        <span className="font-orbitron font-extrabold tracking-[0.2em] text-sm text-white">
          VERI<span className="text-[#ff007f]">TARGA</span>
        </span>
      </a>
      <div className="flex items-center gap-2 font-jetmono text-[10px] tracking-[0.2em] text-[#8a8a9e]">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#00ff88] opacity-60" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-[#00ff88]" />
        </span>
        SISTEMA ONLINE
      </div>
    </motion.header>
  );
}
